// ─────────────────────────────────────────────────────────────────────────────
// API environment toggle
//
// Set USE_LOCAL to true  → talks to local backend at http://localhost:8000
// Set USE_LOCAL to false → talks to production backend at https://api.reactfirst.ai
//
// This is the ONLY place you need to change to switch environments.
// ─────────────────────────────────────────────────────────────────────────────
 
const USE_LOCAL = false; // ← change this to true for local dev

export const API_BASE_URL = USE_LOCAL
  ? 'http://localhost:8000/api'
  : 'https://api.reactfirst.ai/api';

export const IS_LOCAL = USE_LOCAL;

// Standalone, login-free report viewer: the reports.* subdomain, an /r/{token} path,
// or an explicit build flag. Same build serves the dashboard and the reports site, so
// everything auth-dependent must gate on this.
export const IS_REPORTS_MODE =
  typeof window !== 'undefined' &&
  (window.location.hostname.startsWith('reports.') ||
    window.location.pathname.startsWith('/r/') ||
    process.env.REACT_APP_REPORTS_MODE === 'true');

// public/index.html paints a boot screen before React starts, so the prerendered marketing
// landing never flashes on a report link. Call this once the report (or the invalid-link
// message) is on screen — it reveals #root and removes the loader. Safe to call twice.
export const clearReportBootScreen = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.removeAttribute('data-reports');
  const boot = document.getElementById('rf-report-boot');
  if (boot) boot.remove();
};

export default API_BASE_URL;
